import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=7f414857&scoped=true&"
import script from "./BoxCard.vue?vue&type=script&lang=js&"
export * from "./BoxCard.vue?vue&type=script&lang=js&"
import style0 from "./BoxCard.vue?vue&type=style&index=0&id=7f414857&lang=scss&"
import style1 from "./BoxCard.vue?vue&type=style&index=1&id=7f414857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f414857",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f414857')) {
      api.createRecord('7f414857', component.options)
    } else {
      api.reload('7f414857', component.options)
    }
    module.hot.accept("./BoxCard.vue?vue&type=template&id=7f414857&scoped=true&", function () {
      api.rerender('7f414857', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/BoxCard.vue"
export default component.exports